import React, { useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import TaskComponent from "./TaskComponent";

function StickyTaskList({ taskData }) {
  const [key, setKey] = useState("currentStickyList");
  return (
    <div>
      <Tabs
        id="controlled-tab-example"
        activeKey={key}
        onSelect={(k) => setKey(k)}
        style={{ position: "sticky", top: "2rem" }}
        className="bg-white"
      >
        <Tab
          eventKey="currentStickyList"
          title="Current Sticky List"
          className="border-bottom border-x p-3"
        >
          <TaskComponent task={taskData?.currentStickyList} />
        </Tab>
        <Tab
          eventKey="stickyListCompletedByUser"
          title="Sticky List Completed By User"
          className="border-bottom border-x p-3"
        >
          <TaskComponent task={taskData?.stickyListCompletedByUser} />
        </Tab>
        <Tab
          eventKey="stickyListCompletedBySystem"
          title="Task List Completed BY System"
          className="border-bottom border-x p-3"
        >
          <TaskComponent task={taskData?.stickyListCompletedBySystem} />
        </Tab>
        <Tab
          eventKey="upcomingStickyList"
          title="Upcoming Sticky List"
          className="border-bottom border-x p-3"
        >
          <TaskComponent task={taskData?.upcomingStickyList} />
        </Tab>
      </Tabs>
    </div>
  );
}

export default StickyTaskList;
